import { render } from "./filterTicketsTab.vue?vue&type=template&id=b8dca590"
import script from "./filterTicketsTab.vue?vue&type=script&lang=js"
export * from "./filterTicketsTab.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__